import { Grid, InputLabel, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import { useOnChange } from '../../../hooks/useOnChange';
import InputDropdown from '../Dropdown';

interface OwnProps {
  defaultState: { percentage: string };
  defaultValue?: string[];
  onChange: (values: { percentage: string }) => void;
}

export function InputPercentageDropdown({
  onChange,
  defaultState,
  defaultValue = [SHAREHOLDER_PERCENTAGES[4].value],
}: OwnProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [state, setState] = useState<{ percentage: string }>(defaultState);

  useDefaultValueWatcher({ defaultValue: defaultState, state, setState });
  useOnChange(onChange, state);

  return (
    <Grid container direction="column">
      <Grid container justify="space-between" alignItems="center" className={classes.dropdownRoot}>
        <Grid item className={classes.dropdownLabel}>
          <InputLabel>{t('companies:filterInputs.ownershipPercentage')}</InputLabel>
        </Grid>
        <Grid item className={classes.dropdown}>
          <InputDropdown
            label=""
            defaultValue={defaultValue}
            options={SHAREHOLDER_PERCENTAGES}
            onChange={handleDropdownChange}
          />
        </Grid>
      </Grid>
    </Grid>
  );
  function handleDropdownChange(value: string) {
    const newState = {
      ...state,
      percentage: state.percentage,
    };
    if (state.percentage !== value) {
      newState.percentage = value;
    }
    setState(newState);
  }
}

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px 0',
  },
  gridItem: {
    width: '50%',
  },
  gridLabel: {
    margin: theme.spacing(0),
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(4),
    textTransform: 'none',
  },
  dropdownRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
  },
  dropdownLabel: {
    marginRight: theme.spacing(2),
  },
  dropdown: {
    width: '25%',
  },
}));

export const SHAREHOLDER_PERCENTAGES = [
  {
    value: '0',
    label: '0',
  },
  {
    value: '5',
    label: '5',
  },
  {
    value: '10',
    label: '10',
  },
  {
    value: '20',
    label: '20',
  },
  {
    value: '25',
    label: '25',
  },
  {
    value: '30',
    label: '30',
  },
  {
    value: '33',
    label: '33',
  },
  {
    value: '40',
    label: '40',
  },
  {
    value: '50',
    label: '50',
  },
  {
    value: '60',
    label: '60',
  },
  {
    value: '66',
    label: '66',
  },
  {
    value: '70',
    label: '70',
  },
  {
    value: '75',
    label: '75',
  },
  {
    value: '80',
    label: '80',
  },
  {
    value: '90',
    label: '90',
  },
  {
    value: '95',
    label: '95',
  },
  {
    value: '100',
    label: '100',
  },
];
